// extracted by mini-css-extract-plugin
module.exports = {"container":"Page_container__7xHEo","blocks":"Page_blocks__2uUl0","phone":"Page_phone__2u_lG","notification":"Page_notification__3WLUn"};